import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import GalleryHero from "./components/GalleryHero";
import GalleryGrid from "./components/GalleryGrid";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Gallery() {
  useScrollToTop();
  return (
    <div className="min-h-screen bg-brand-cream font-sans">
      <Navbar />
      <main className="pt-0">
        <GalleryHero />
        <GalleryGrid />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
